const Header = () => import('@/components/center/header');
const Footer = () => import('@/components/center/footer');
const centerHome = () => import('@/views/center/centerHome.vue');
const centerSet = () => import('@/views/center/centerSet.vue');
const centerReward = () => import('@/views/center/centerReward.vue');
const centerPenalty = () => import('@/views/center/centerPenalty.vue');
const centerPersonal = () => import('@/views/center/centerPersonal.vue');

export default [
    {
        path: '/centerHome',
        name: 'centerHome',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '绩效管理中心',
        },
        components: {
            default: centerHome,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/centerSet',
        name: 'centerSet',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '专管员奖惩录入',
        },
        components: {
            default: centerSet,
            header:Header,
        }
    },
    {
        path: '/centerReward',
        name: 'centerReward',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '奖励列表',
        },
        components: {
            default: centerReward,
            header:Header,
        }
    },
    {
        path: '/centerPenalty',
        name: 'centerPenalty',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '惩罚列表',
        },
        components: {
            default: centerPenalty,
            header: Header,
        }
    },
    {
        path: '/centerPersonal',
        name: 'centerPersonal',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '',
        },
        components: {
            default: centerPersonal,
            header:Header,
            footer:Footer,
        }
    },
];




